import { render, staticRenderFns } from "./ActionCenterTable.vue?vue&type=template&id=7df96018"
import script from "./ActionCenterTable.vue?vue&type=script&lang=js"
export * from "./ActionCenterTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports